import { createFileRoute } from '@tanstack/react-router';
import { UsersPage } from '@/features/admin/users-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/admin/users')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/admin/users');
  },
  component: UsersPage,
});
